import { render, staticRenderFns } from "./AgentSignUpPage.vue?vue&type=template&id=7745c230&"
import script from "./AgentSignUpPage.vue?vue&type=script&lang=js&"
export * from "./AgentSignUpPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports